import { useQuery } from '@tanstack/react-query'

import { type IPackagingType } from '../../types'
import { useUpFetch } from '../../utils'

export const useAllFreightTypes = () => {
  const upFetch = useUpFetch()

  return useQuery({
    async queryFn(): Promise<IPackagingType[]> {
      try {
        const res = await upFetch<{ data: IPackagingType[] }>('/public/packaging-types')

        return res.data
      } catch (error) {
        console.error('Error fetching freight types:', error)
        return []
      }
    },
    queryKey: ['/public/packaging-types'],
  })
}
